import { Alert, AlertType, PageHeaderRedesign } from '@egw/components'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { CUSTOMER_SERVICE_PHONE_NUMBER, WEALTH_ROUTES } from '@egw/constants'

export const RedesignFoundationPage: FC = () => {
  const { t } = useTranslation('features-foundation')

  return (
    <>
      <PageHeaderRedesign
        title={t('redesign.title')}
        subtitle={t('redesign.subtitle')}
        backLinkUrl={WEALTH_ROUTES.EVERGREEN_ACCOUNTS.path}
      />
      <div className="egw-container flex flex-col gap-lg mt-lg">
        <h1 className="typo-primary-cl-regular text-text-body">{t('redesign.h1')}</h1>
        <div className="w-[64px] border border-taupe-300 rounded-lg" />

        <div className="flex flex-col gap-sm">
          <p className="typo-primary-base-regular text-text-body">{t('redesign.p1')}</p>
          <p className="typo-primary-base-regular text-text-body">{t('redesign.p2')}</p>
        </div>
        <Alert alertType={AlertType.Info} showIcon={false} className="text-sky-600 typo-primary-base-regular p-xs">
          <Trans t={t} i18nKey="redesign.learn_more">
            <a
              className="text-btnLinkText hover:text-btnLinkTextHover hover:underline font-semibold contents"
              href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
            >
              {CUSTOMER_SERVICE_PHONE_NUMBER}
            </a>
          </Trans>
        </Alert>
      </div>
    </>
  )
}
